<p-dialog header="{{ 'h3.titlePicking' | translate }}" [(visible)]="displayModal" [modal]="true" class="container">
	<div *ngIf="stocks" class="container__radio-button">
		<div class="field-radiobutton">
			<p-radioButton name="groupname" value="{{ this.stocks[0].stockTypeUidK }}" [(ngModel)]="selectedValue" inputId="primary"></p-radioButton>
			<label for="primary">  {{ 'label.picking' | translate }}</label>
		</div>
		<div class="field-radiobutton">
			<p-radioButton name="groupname" value="{{ this.stocks[1].stockTypeUidK }}" [(ngModel)]="selectedValue" inputId="reserve"></p-radioButton>
			<label for="reserve">  {{ 'label.reserve' | translate }}</label>
		</div>
		<div class="field-radiobutton">
			<p-radioButton name="groupname" value="{{ this.stocks[3].stockTypeUidK }}" [(ngModel)]="selectedValue" inputId="others"></p-radioButton>
			<label for="others">  {{ 'label.others' | translate }}</label>
		</div>
	</div>
	<div class="container__button">
		<p-button (click)="closeDialog()" label="Ok"></p-button>
	</div>
</p-dialog>
